import {createUseQuery, createUseMutation} from "@irati/utils/services/apollo"
import {
  MutationCreatePaymentContextArgs,
  MutationRequestPaymentArgs,
  Payment,
  PaymentConfigs,
  PaymentContext,
  QueryPaymentConfigsArgs
} from "@irati/types"
import getPaymentConfigs, {paymentConfigsQueryKey} from "../services/queries/getPaymentConfigs"
import requestPaymentMutation, {requestPaymentKey} from "../services/mutations/requestPaymentMutation"
import createPaymentContextMutation, {createPaymentContextKey} from "../services/mutations/createPaymentContextMutation"
import isCheckoutDotComEnabled, {isCheckoutDotcomEnabledQueryKey} from "../services/queries/isCheckoutDotComEnabled"
import paymentErrorHandler from "../errorHandler"

export const usePaymentConfigsQuery = createUseQuery<PaymentConfigs, QueryPaymentConfigsArgs>(getPaymentConfigs, {
  errorHandlers: [paymentErrorHandler],
  key: paymentConfigsQueryKey
})

export const useIsCheckoutDotcomEnabledQuery = createUseQuery<PaymentConfigs>(isCheckoutDotComEnabled, {
  errorHandlers: [paymentErrorHandler],
  key: isCheckoutDotcomEnabledQueryKey
})

export const useRequestPaymentMutation = createUseMutation<Payment, MutationRequestPaymentArgs>(requestPaymentMutation, {
  errorHandlers: [paymentErrorHandler],
  key: requestPaymentKey
})

export const useCreatePaymentContextMutation = createUseMutation<PaymentContext, MutationCreatePaymentContextArgs>(
  createPaymentContextMutation,
  {
    errorHandlers: [paymentErrorHandler],
    key: createPaymentContextKey
  }
)
